<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <div class="input-group">
      <date-picker
        v-model="inputValue"
        v-facade="dateMask"
        :id="inputId"
        :disabled="disabled"
        :value-type="dateValueType"
        :format="dateFormat"
        :disabled-date="isDisabledDate"
        @input="emitValue('input', $event)"
        @change="emitValue('change', $event)"
        @blur="emitValue('change', $event)"
      />
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import datePickerConfigMixin from '../../../../mixins/application-form/datePickerConfigMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'BirthdayInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    datePickerConfigMixin
  ],

  props: {
    inputLabel: {
      default: 'Дата рождения'
    },

    inputName: {
      default: 'birthday'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId () {
      let inputId = `form-visitor-birthday-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-birthday`
      }

      return inputId
    }
  }
}
</script>
